/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ApplicantData
 */
export interface ApplicantData {
  /**
   *
   * @type {string}
   * @memberof ApplicantData
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ApplicantData
   */
  identifier: string
  /**
   *
   * @type {string}
   * @memberof ApplicantData
   */
  address: string
}

/**
 * Check if a given object implements the ApplicantData interface.
 */
export function instanceOfApplicantData(value: object): value is ApplicantData {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('identifier' in value) || value['identifier'] === undefined)
    return false
  if (!('address' in value) || value['address'] === undefined) return false
  return true
}

export function ApplicantDataFromJSON(json: any): ApplicantData {
  return ApplicantDataFromJSONTyped(json, false)
}

export function ApplicantDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicantData {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    identifier: json['identifier'],
    address: json['address'],
  }
}

export function ApplicantDataToJSON(value?: ApplicantData | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    identifier: value['identifier'],
    address: value['address'],
  }
}
